import { atom } from 'recoil';
import { SessionType } from '../types/SessionType';

export const SessionState = atom<SessionType>({
  key: 'SessionState',
  default: {
    current: null,
  },
});
